import './router/componentHooks';
import Vue from 'vue';
import Vant, { Dialog, Toast } from 'vant';
import { Lazyload } from "vant";
import 'vant/lib/index.css';
import './scss/index.scss';
// 试题等富文本内容通过 v-latex 支持 $...$ / $$...$$ LaTeX 数学公式渲染
import '@/utils/directive/latexDirective';
import wm from '@/utils/wsm.index';
import VConsole from 'vconsole';
import moment from 'moment';
import websocketMessageModule from './utils/websocketMessage';
import { nav, NoData } from './components';
import App from './App.vue';
import router from './router';
import store from './store';
import VueTouch from 'vue-touch';
// 移除全局百度地图注册，改为在需要时动态加载
// import BaiduMap from 'vue-baidu-map';
import {getUrlQuery,makeIcon,getSchoolConfig,isCourseAuth} from '@/utils/utils';
import loginApi from '@/apis/login/login';
import urlConfig from '@/Configurations/urlConfig';
import VueLazyload from 'vue-lazyload'
const { version } = require('../package.json');
import infiniteScroll from 'vue-infinite-scroll';
import VueClipboard from 'vue-clipboard2'
import {unescape} from '@/utils/utils';
import VueRouterReferer from '@tozd/vue-router-referer';
import i18n from './lang/index';


//import 'amfe-flexible/index.js';

if(process.env.VUE_APP_ENV === 'test') {
  // 测试环境启用
  new VConsole({});
}

//初始化页面
function initVueData(){
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}
//显示最原始的配置
function showOriginConfig(){
  let schoolConfigObj = getSchoolConfig();
  if(schoolConfigObj){
    document.title = schoolConfigObj['schoolName'];
    if(schoolConfigObj['appid'] && schoolConfigObj['appid'].length>0){
      window.localStorage.setItem('appid_cache',schoolConfigObj['appid']);
    }
    makeIcon(schoolConfigObj['ico_url']);
    initVueData();
  }else{
    document.title = urlConfig.appName;
    makeIcon('/favicon.ico');
    initVueData();
  }
}

// 全局注册
Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(Vant);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(nav);
Vue.use(NoData);
Vue.use(wm);
Vue.use(VueLazyload);
// 移除全局百度地图注册，改为在通用地图组件中按需加载
// Vue.use(BaiduMap, {
//   ak: 'TVhjYjq1ICT2qqL5LdS8mwas'
// })
Vue.use(infiniteScroll);
Vue.use(VueClipboard)
Vue.prototype.$moment = moment;
Vue.prototype.$moment.locale('zh-cn');
Vue.config.productionTip = false;
Vue.use(VueRouterReferer);
Vue.use(Lazyload);

/**
 * 登录弹窗提醒
 */
 Vue.prototype.loginTipsDialog = function() {
   this.$dialog.confirm({
     title: '提示',
     message: '还未登录，是否先登录？',
   }).then(() => {
     sessionStorage.from = location.href;
     location.href = '/login';
   })
}

Vue.prototype.filterElement = function (value: string) {
  if (!value) return ''
  let tmp =  value.replace(/<img (.*?) \/>/gi, '[图片]')
              .replace(/<.*?>/gi, '');

  return unescape(tmp);
}

/**
 * 打开新窗口
 */
Vue.prototype.openNewWindow = function(href: string) {
  location.href = href;
}

//课程功能模块权限鉴定
Vue.prototype.isCourseAuth = function(bindVal:any) {
  return isCourseAuth(bindVal);
}

//忽略标签部分
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
];

//发现带有此参数
let mobilexdomain = getUrlQuery('mobilexdomain');
let appid = getUrlQuery('appid');
if(mobilexdomain && mobilexdomain.length>0){
  loginApi.getSchoolConfig({school:mobilexdomain}).then((res)=>{
    if(res && res['mobileBanner'] && res['mobileBanner'].length>0){
      res['mobilexdomain'] = mobilexdomain;
      window.localStorage.setItem('schoolConfig',JSON.stringify(res));
      document.title = res['schoolName'];
      if(res['appid'] && res['appid'].length>0){
        window.localStorage.setItem('appid_cache',res['appid']);
      }
      makeIcon(res['ico_url']);
      initVueData();
    }else{
      //无个性化配置但处于迁移交割期的学校，也要能拿到交割状态
      if(res && res['migration']){
        window.localStorage.setItem('migrationInfo',JSON.stringify(Object.assign({},res['migration'],{_ts:Date.now()})));
      }else{
        //已不在交割期：清掉本地暂存，避免一直卡在拦截画面
        window.localStorage.removeItem('migrationInfo');
      }
      showOriginConfig();
    }
  });
}else{
  if(appid && appid.length>0){
    loginApi.getSchoolConfig({appid:appid}).then((res)=>{
      if(res){
        window.localStorage.setItem('schoolConfig',JSON.stringify(res));
        document.title = res['schoolName'];
        if(res['appid'] && res['appid'].length>0){
          window.localStorage.setItem('appid_cache',res['appid']);
        }
        makeIcon(res['ico_url']);
        initVueData();
      }else{
        showOriginConfig();
      }
    });
  }else{
    showOriginConfig();
  }
}
console.log(`当前软件版本为:${version}`);
